import { render, staticRenderFns } from "./CommunityB2bInvites.vue?vue&type=template&id=e0ed8d84&scoped=true&"
import script from "./CommunityB2bInvites.vue?vue&type=script&lang=ts&"
export * from "./CommunityB2bInvites.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityB2bInvites.vue?vue&type=style&index=0&id=e0ed8d84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ed8d84",
  null
  
)

export default component.exports